import z from "zod";

import { patch } from "../api-canvas-metadata/Patch";

/**
 * Instructs the client to the state sync server. Authorization header is used to retrieve the
 * initial state from the Moment GraphQL API.
 */
export const connectEvent = z.object({
	type: z.literal("connect"),
	extra: z.optional(z.unknown()),
});

/**
 * Instructs the client to the state sync server. Authorization header is used to retrieve the
 * initial state from the Moment GraphQL API.
 */
export type ConnectEvent = z.infer<typeof connectEvent>;

/**
 * Instructs state sync client to disconnect from the server.
 */
export const disconnectEvent = z.object({ type: z.literal("disconnect") });

/**
 * Instructs state sync client to disconnect from the server.
 */
export type DisconnectEvent = z.infer<typeof disconnectEvent>;

/**
 * Pauses or unpauses the transaction processing from the client.
 */
export const setTransactionProcessingPausedEvent = z.object({
	type: z.literal("setTransactionProcessingPaused"),
	paused: z.boolean(),
});

/**
 * Pauses or unpauses the transaction processing from the client.
 */
export type SetTransactionProcessingPausedEvent = z.infer<
	typeof setTransactionProcessingPausedEvent
>;

export const enqueueTransactionOptions = z.object({
	// Allows for the caller to skip optimistically updating the local cache on the enqueued transactions
	// Default is false.
	avoidOptimisticUpdate: z.boolean().optional(),
	// Blob of extra data that can be used in any context.
	extras: z.unknown().optional(),
});

export const enqueueTransaction = z.object({
	type: z.literal("enqueueTransaction"),
	transactionId: z.string().optional(),
	patches: z.array(patch),
	options: enqueueTransactionOptions.optional(),
});
export type EnqueueTransaction = z.infer<typeof enqueueTransaction>;

export type EnqueueTransactionOptions = z.infer<typeof enqueueTransactionOptions>;

/**
 * Events that can be passed to the state sync client.
 */
export type StateSyncClientEvent =
	| ConnectEvent
	| DisconnectEvent
	| SetTransactionProcessingPausedEvent
	| EnqueueTransaction;
